import { Axios } from "../hooks/useAxiosInstance";

export const Blog = (function () {


    const apis = () => ({
        create: async (data, api_token) => await createRecord(data, api_token),
        get: async (api_token) => await getRecord(api_token),
        update: async (data, api_token) => await updateRecord(data, api_token),
        delete: async (slug, api_token) => await deleteRecord(slug, api_token)

    })

    async function createRecord(data, api_token) {
        const url = "admin/blog";
        const option = {
            headers: {
                'Authorization': api_token,
                'Content-Type': 'multipart/form-data'
            }
        }

        return await Axios.post(url, data, option);
    }
    async function getRecord(api_token) {
        const url = "admin/blog";
        const option = {
            headers: {
                'Authorization': api_token,
            }
        }

        return await Axios.get(url, option);
    }
    async function updateRecord(data, api_token) {
        const url = "admin/blog/" + data.slug;
        const option = {
            headers: {
                'Authorization': api_token,
            }
        }

        return await Axios.patch(url, data, option);
    }
    async function deleteRecord(slug, api_token) {
        const url = "admin/blog/" + slug;
        const option = {
            headers: {
                'Authorization': api_token,
            }
        }

        return await Axios.delete(url, option);
    }

    return apis();

})()
